import { FabricObject, Textbox } from 'fabric';

export function isTextbox(obj: FabricObject | undefined): obj is Textbox {
  return obj?.type.toLowerCase() === 'textbox';
}
